import React from "react";
import { default as WListItemIcon } from "@mui/material/ListItemIcon";

function ListItemIcon(props) {
  return <WListItemIcon {...props} />;
}

export default ListItemIcon;
